// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"styles/colors.css\"","zRed":"rgb(237, 85, 100)","card":"_1sYe","title":"_3Kex","body":"_2Pto","error":"P3-s"};


//////////////////
// WEBPACK FOOTER
// ./src/features/Flows/FlowLogEvent/FlowLogEvent.scss
// module id = 0nIN
// module chunks = 0